import { requestDemo } from '../../../../shared/api/demo.js'
import { busy, error, step } from './status.js'
import { getHubSpotCookie } from '../../../../shared/etc/hubspot.js'

export const EMAIL_UPDATE = 'EMAIL_UPDATE'

export function request(firstName, lastName, emailAddress, phoneNumber, source) {
	return dispatch => {
		dispatch(busy('Submitting request...'))

		// Capture HubSpot cookie, default to '0' if not found
		const hubspotCookie = getHubSpotCookie() || '0'

		return requestDemo(emailAddress, firstName, lastName, phoneNumber, hubspotCookie, source).then(response => {

			dispatch(update({
				firstName: firstName,
				lastName: lastName,
				address: emailAddress,
				phoneNumber: phoneNumber,
				validated: true,
				preauthToken: response.preauthToken
			}))
			dispatch(step('verify'))
			dispatch(busy(false))

		}).catch(err => {

			if (err.response) {

				// API response provided
				switch (err.response.status) {
					case 400: {
						err.response.json().then(res => {
							const { message } = res

							if (message === undefined) {
								dispatch(error('An unknown error has occurred [D01]'))
							} else {
								dispatch(error(message))
							}
						})
					} break

					case 403: {
						// Domain not approved - construct message with domain from email
						const domain = emailAddress.split('@')[1]
						const message = `Merlin™ demos are currently available by request for approved companies. To begin the application process or request access, please contact <a href="mailto:sales@powermonitors.com">sales@powermonitors.com</a>`
						dispatch(error(message))
					} break

					case 500: {
						dispatch(error('Registration service unavailable [D03]'))
					} break

					default: {
						dispatch(error('An unknown error has occurred [D04]'))
					} break
				}

			} else {
				// API response is missing
				dispatch(error('An unknown server error has occurred [D05]'))
			}
		})
	}
}

export function update(payload) {
	return {
		type: EMAIL_UPDATE,
		payload
	}
}
